<app-signature-request
  [signatureStatus]="signatureStatus"
  [primaryContactDateSigned]="dateSigned$ | async"
  [signatureRequestSending]="signatureRequestSending$ | async"
  [signedDate]="signedDate"
  [contactId]="contact.id"
  [isPrimary]="contact.isPrimary"
  [signatureRequestSent]="signatureRequestSent"
  (sendSignatureEvent)="sendSignatureRequest()">
</app-signature-request>
